import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";

export default () =>
  window[asosGlobalNamespace][siteChromeGlobalNamespace].templateVersioning
    ?.templateKey ?? undefined;
